import { addDays, createCurrentDate, isAfter } from '@expane/date'
import { Card } from '@expane/logic/cards'
import { FieldNamesMarkedBoolean } from 'react-hook-form'

// не активированные в контексте сертификатов значит, что он был продан, но деньги на счет клиента не поступили
export const getGiftCardsThatWasNotActivated = <T extends Card & { createdAt: Date }>(
  clientCards: T[],
  timezone: string | undefined,
) => {
  return clientCards.filter(({ activatedAt, cardPeriod, createdAt }) => {
    // не активированные и при этом нет срока действия
    if (!activatedAt && cardPeriod === 0) return true
    // не активированные и при этом есть срок действия, то проверяем или сертификат не просрочен
    return (
      !activatedAt &&
      cardPeriod !== 0 &&
      isAfter(addDays(createdAt, cardPeriod), createCurrentDate(timezone))
    )
  })
}

// мы получаем объект с полями формы и значением true/false если оно изменилось
// функция нужна для того чтоб проверить какие именно поля были изменены
// сделана под форму абонементов, с учетом того что мы знаем что у нас один уровень вложенности
export const getDirtyFields = <T extends { name: string }>(fields: FieldNamesMarkedBoolean<T>) => {
  let areFieldsExceptNameDirty = false

  for (const field in fields) {
    const fieldValue = fields[field]

    const isFieldValueArray = Array.isArray(fieldValue)

    if (isFieldValueArray) {
      for (const valueOfField of fieldValue) {
        // если хотя бы одно значение true - то поле isDirty
        if (fieldValue[valueOfField] && field !== 'name') areFieldsExceptNameDirty = true
      }
    }

    if (!isFieldValueArray && fieldValue && field !== 'name') areFieldsExceptNameDirty = true
  }

  // TODO: Покращити логіку
  let isNameDirty = false
  if (typeof fields !== 'boolean') isNameDirty = fields.name ?? false

  return { isNameDirty, areFieldsExceptNameDirty }
}
